import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Field,reduxForm,formValueSelector,submit,change } from 'redux-form';
import RFCheckboxField from '../../components/ReduxFormComps/RFCheckboxField';
import RFAutoCompleteField from '../../components/ReduxFormComps/RFAutoCompleteField';
import renderTextField from '../../components/MaterialUi/renderTextField';
import * as actions from '../../redux/gorgon/actions';
import collect from 'collect.js'
import ActionConfirmDialog from '../../components/ActionConfirmDialog';
import * as actConfDlgActions from '../../redux/actConfDialog/actions';
import Paper from 'material-ui/Paper'

const renderSubmitButton=props=>{
    const { pristine,submitting,gorgon,invalid } = props;
    const { formError } = gorgon;
    
    if (!invalid && !Object.keys(formError).length > 0 ){
        return (
            <div>
                <button type="button" onClick={()=> props.submitOpenActionDialog()} 
                className="btn btn-primary btn-lg" disabled={pristine || submitting} >Submit Your Answer</button>
                <br/><br/>
            </div>    
        )
    }
    return null;
}

const autoCompleteDataSourceConfig = {
    text: 'form_num',
    value: 'form_num',
};

const renderFormNumElement=(isOverrideFormNum,gorgon,dis)=>{
    if (!isOverrideFormNum){
        return (
            <Field
                label="Form Number"
                name="formNum"
                dataSource={gorgon.forms}
                dataSourceConfig={autoCompleteDataSourceConfig}
                component={RFAutoCompleteField}
                fullWidth={true}
                onChange={dis.formNumOnChange.bind(dis)}
            />
        )
    }else {
        return (
            <Field
                name="formNum"
                component={renderTextField}
                label="Form Number"
                style={{width: '270px'}}
            />
        )
    }
}

const isOverrideFormNumOnChange=(e,props)=>{
    if (e.target.checked){
        props.clearSelectedFormNum();
        props.changeFieldValue('formNum','')
    }
}

class DocDecisionAndActionSubmit extends React.Component {
    
    componentWillMount(){
        const { jwt,isPROD } = this.props;
        this.props.populateFormsList(jwt,isPROD);
    }

    formNumOnChange(e){
        const { gorgon,jwt,isPROD } = this.props
        const collection=collect(gorgon.forms)
        if (e){
            const inputObj = collect(e)
            let getFormNum=""
            if (inputObj.contains("0")) getFormNum+=inputObj.get("0")
            if (inputObj.contains("1")) getFormNum+=inputObj.get("1")
            if (inputObj.contains("2")) getFormNum+=inputObj.get("2")
            if (inputObj.contains("3")) getFormNum+=inputObj.get("3")
            if (inputObj.contains("4")) getFormNum+=inputObj.get("4")
            if (inputObj.contains("5")) getFormNum+=inputObj.get("5")
            if (getFormNum){
                const gorgonForm=collection.firstWhere('form_num',getFormNum)
                this.props.populateFormQuestionsList(jwt,gorgonForm.id,isPROD)
            }else {
                this.props.clearSelectedFormNum()
            }
        }
    }

    render(){
        const { gorgon,jwt,taskAcceptedInfoId,isOverrideFormNum } = this.props;
        const dis=this; 
        if (gorgon.docSubmitted) {
            return <Redirect to='/projectGorgon/docSubmittedAckForm' />;
        }

        return (
            <div>
                <Paper>
                    <div className="container">
                        <div className="row">
                            <div className='col-sm-5'>
                                <Field name="isDocNotLoad" 
                                component={RFCheckboxField} 
                                label="Document Does Not Load" />
                            </div>
                            <div className='col-sm-7'>
                                <Field name="isDocInvalid" 
                                component={RFCheckboxField} 
                                label="Document is Not Valid (eg. Multiple Documents)" />
                            </div>
                        </div>
                        <div className="row">
                            <div className='col-sm-5'>
                            {renderFormNumElement(isOverrideFormNum,gorgon,dis)}
                            </div>
                            <div className='col-sm-7'>
                                <Field name="isOverrideFormNum" 
                                component={RFCheckboxField} 
                                label={'Form Number Not Found in Dropdown'}
                                onChange={(e)=>isOverrideFormNumOnChange(e,this.props)}
                                />
                            </div>    
                        </div>    
                        <div className="row">
                            <div className='col-sm'>
                                <Field name="isNoFormNumInDoc" 
                                component={RFCheckboxField} 
                                label="No Form Number in Document" />
                            </div>
                            <div className='col-sm'>
                                {renderSubmitButton(this.props)}
                            </div>
                        </div>    
                        <div className="row">
                            <div className="col-sm">
                                <ActionConfirmDialog 
                                    title={'Gorgon Document Data Extraction'}
                                    message={'Please do double check and confirm all your inputs before click submit.'}
                                    submitFunc={this.props.submitReduxForm}
                                /> 
                            </div>
                        </div>   
                    </div>
                </Paper>
            </div>
        )
    }
    
}

const mapStateToProps = (state, ownProps) => {
    return {
        gorgon: state.gorgon
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
      docSubmissionCompleted: () => {
         dispatch(actions.docSubmissionCompleted())  
      },
      populateFormsList: (jwt,isPROD) => {
        dispatch(actions.populateFormsList(jwt,isPROD))  
      },
      populateFormQuestionsList: (jwt,gorgonFormId,isPROD) => {
        dispatch(actions.populateFormQuestionsList(jwt,gorgonFormId,isPROD))  
      },
      submitOpenActionDialog: ()=> {
        dispatch(actConfDlgActions.openDialog())    
      },
      clearSelectedFormNum: () => {
        dispatch(actions.clearSelectedFormNum())  
      }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(DocDecisionAndActionSubmit);


// WEBPACK FOOTER //
// ./src/views/ProjectGorgon/DocDecisionAndActionSubmit.js